import { render, staticRenderFns } from "./OfferThemeCoreRegister.vue?vue&type=template&id=ca31fe94"
import script from "./OfferThemeCoreRegister.vue?vue&type=script&lang=js"
export * from "./OfferThemeCoreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca31fe94')) {
      api.createRecord('ca31fe94', component.options)
    } else {
      api.reload('ca31fe94', component.options)
    }
    module.hot.accept("./OfferThemeCoreRegister.vue?vue&type=template&id=ca31fe94", function () {
      api.rerender('ca31fe94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/OfferThemeCoreRegister.vue"
export default component.exports